import {LocalDate, LocalTime} from "@js-joda/core";
import {TimeEntry} from "../pages/TimeEntries";

export type RawTimeEntry = Omit<TimeEntry, 'startDate' | 'startTime'> & {
    startDate : string;
    startTime : string;
};


export const mapRawTimeEntry = (rawTimeEntry : RawTimeEntry) : TimeEntry => ({
    ...rawTimeEntry,
    startDate: LocalDate.parse(rawTimeEntry.startDate),
    startTime: rawTimeEntry.startTime ? LocalTime.parse(rawTimeEntry.startTime).withSecond(0) : null,
    task: rawTimeEntry.task ? {...rawTimeEntry.task} : null,
    project: rawTimeEntry.project ? {...rawTimeEntry.project} : undefined,
    component: rawTimeEntry.component ? {...rawTimeEntry.component} : undefined,
});
